import axios from "axios";
import React, { useEffect, useMemo } from "react";
import { createContext, useState } from "react";
export const DistributorFormContext = createContext();

function FormContext({ children, editData }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [creditType, setCreditType] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [earningFeesType, setEarningFeesType] = useState("%");
  const [earningAmountType, setEarningAmountType] = useState("%");
  const [earningFeesValue, setEarningFeesValue] = useState("");
  const [earningAmountValue, setEarningAmountValue] = useState("");
  const [applicableFeesValue, setApplicableFeesValue] = useState("");
  const [applicableRateValue, setApplicableRateValue] = useState("");
  const [existLogo, setExistLogo] = useState(null);
  const [editMode, setEditMode] = useState(editData ? true : false);
  const [imageLoading, setImageLoading] = useState(false);

  const memoizedValue = useMemo(
    () => ({
      email,
      setEmail,
      name,
      setName,
      creditType,
      setCreditType,
      selectedImage,
      setSelectedImage,
      earningFeesType,
      setEarningFeesType,
      earningAmountType,
      setEarningAmountType,
      earningFeesValue,
      setEarningFeesValue,
      earningAmountValue,
      setEarningAmountValue,
      applicableFeesValue,
      setApplicableFeesValue,
      applicableRateValue,
      setApplicableRateValue,
      existLogo,
      setExistLogo,
      editMode,
      setEditMode,
      imageLoading,
      setImageLoading,
    }),
    [
      name,
      email,
      creditType,
      selectedImage,
      earningFeesType,
      earningAmountType,
      earningFeesValue,
      earningAmountValue,
      applicableFeesValue,
      applicableRateValue,
      existLogo,
      editMode,
      imageLoading,
    ]
  );
  const fetchDistributorDetails = async () => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/distributors/${editData.id}`,
        options
      );
      if (res.data) {
        const { distributor_detail } = res.data;

        setName(distributor_detail?.name || "");
        setEmail(distributor_detail?.email || "");
        setCreditType(distributor_detail?.credit_type || null);

        distributor_detail.logo && setExistLogo(distributor_detail.logo);

        const { details } = distributor_detail || {};

        setDetailsValue(
          details?.earning_processing_fee_percentage,
          setEarningFeesValue,
          setEarningFeesType,
          "%"
        );
        setDetailsValue(
          details?.earning_processing_fee_inr,
          setEarningFeesValue,
          setEarningFeesType,
          "INR"
        );

        setDetailsValue(
          details?.earning_loan_amount_percentage,
          setEarningAmountValue,
          setEarningAmountType,
          "%"
        );
        setDetailsValue(
          details?.earning_loan_amount_inr,
          setEarningAmountValue,
          setEarningAmountType,
          "INR"
        );
        setDetailsValue(
          details?.roi_processing_fee_percentage,
          setApplicableFeesValue
        );
        setDetailsValue(
          details?.rate_of_interest_percentage,
          setApplicableRateValue
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  useEffect(() => {
    if (editData) {
      fetchDistributorDetails();
    }
  }, []);
  const setDetailsValue = (
    value,
    setValue,
    setType = null,
    typeValue = null
  ) => {
    if (value) {
      setValue(value);
      if (setType && typeValue) setType(typeValue);
    }
  };

  return (
    <DistributorFormContext.Provider value={memoizedValue}>
      {children}
    </DistributorFormContext.Provider>
  );
}

export default FormContext;
